import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/login";
import { enRouteOptions } from "@/lib/route-i18n";

export const Route = createFileRoute("/en/login")(
  enRouteOptions(routeOptions, {
    svPath: "/login",
    title: 'Sign in – Alkoholprovet',
    description: 'Sign in to your Alkoholprovet account.',
    noindex: true,
  }),
);
